import { useState } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { parseDoubleEncodedJson } from '../../utils/apiHelpers';

interface AddUrlPayload {
    entity_id: string | number;
    url: string;
    url_type_id: string | number;
}

interface AddUrlResponse {
    success?: boolean;
    ENT_ENTITY_URL_ID?: string | number;
    id?: string | number;
    URL?: string;
    URL_TYPE_ID?: string;
    message?: string;
    [key: string]: any;
}

const useAddUrl = () => {
    const { authFetch, isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const addUrl = async (payload: AddUrlPayload): Promise<AddUrlResponse | null> => {
        if (!isReady || !workspaceId) {
            setError('Workspace not ready');
            return null;
        }

        setIsLoading(true);
        setError('');
        try {
            const result = await authFetch('/addEntEntityUrl', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            return parseDoubleEncodedJson(result) || { success: true };
        } catch (err: unknown) {
            const message = err instanceof Error ? err.message : 'Unknown error while creating the URL.';
            console.error('[useAddUrl] failed:', { workspaceId, payload, message });
            setError(message);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return { addUrl, isLoading, error };
};

export default useAddUrl;
